import React, { useState, useEffect, useRef } from "react";
import Button from "../SelectValue/Button";
import PinInput from "react-pin-input";
import { useNavigate } from "react-router-dom";
import postService from "../../Services/post-service";
import Loading from "../SelectValue/Loading";
import Logo from "../../Assets/images/Zlogo.png";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function VerifyAccountForm() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const verifiedRef = useRef(false);

  const email = sessionStorage.getItem("sEmail");
  const password = sessionStorage.getItem("sPassword");
  const authSource = sessionStorage.getItem("authSource");

  useEffect(() => {
    if (!verifiedRef.current && (!email || !password)) {
      if (authSource === "login") {
        toast.error("Login session expired. Please log in again.");
        navigate("/");
      } else {
        toast.error("Signup session expired. Please sign up again.");
        navigate("/sign-up");
      }
    }
  }, [email, password, navigate, authSource]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (pin.length !== 6) {
      toast.error("Enter the 6-digit OTP");
      return;
    }

    setOpen(true);

    postService.verifyEmail(email, pin).then(
      (response) => {
        setOpen(false);

        if (response.data?.statusCode === 200) {
          const token = response.data.data.token;
          const expiry = new Date(Date.now() + 15 * 60 * 1000); // 15minutes to match login

          cookie.save("jwttoken", token, { path: "/", expires: expiry });
          cookie.save("token", token, { path: "/", expires: expiry });

          verifiedRef.current = true;
          sessionStorage.removeItem("sPassword");
          sessionStorage.removeItem("authSource");

          toast.success("Account verified successfully");

          setTimeout(() => {
            navigate("/createpin");
          }, 1500);
        } else {
          toast.error(response.data.description);
        }
      },
      (error) => {
        setOpen(false);
        toast.error(
          error.response?.data?.description ||
            "Verification failed. Please try again."
        );
      },
    );
  };

  const resendOtp = () => {
    setOpen(true);

    postService.resendOtp(email).then(
      (response) => {
        setOpen(false);

        if (response.data?.statusCode === 200) {
          toast.success("OTP resent successfully");
        } else {
          toast.error(response.data?.description);
        }
      },
      (error) => {
        setOpen(false);
        toast.error(error.response?.data?.description);
      },
    );
  };

  return (
    <div className="bg-signin-bg h-[95vh]">
      <div className="grid h-[85vh] place-items-center p-3 md:p-0">
        <Loading open={open} />

        <div className="md:w-1/3 bg-white rounded-[16px] shadow-lg p-5 md:p-10">
          <img src={Logo} width="152" height="40" alt="logo" />

          <h1 className="pt-7 text-[18px] md:text-[32px] font-[500] text-back-color2 mb-5">
            Please verify your account
          </h1>

          <p className="mb-3 text-[#44474E]">
            An OTP has been sent to <strong>{email}</strong>. Enter the 6-digit
            code to continue.
          </p>

          <form onSubmit={onSubmit}>
            <div className="w-full flex justify-center mt-5">
              <PinInput
                length={6}
                value={pin}
                onChange={(value) => setPin(value)}
                type="numeric"
                inputMode="number"
                secret
                autoSelect
                inputStyle={{
                  borderColor: "#00BC67",
                  backgroundColor: "#FAFBFC",
                  borderRadius: 8,
                }}
                inputFocusStyle={{
                  borderColor: "#00BC67",
                  backgroundColor: "#CCF2E1",
                }}
                onComplete={(value) => setPin(value)}
              />
            </div>

            <div className="grid grid-cols-1 mb-5 mt-6">
              <Button name="Verify account" />
            </div>
          </form>

          <p className="text-center">
            Didn’t get OTP?
            <button
              type="button"
              onClick={resendOtp}
              className="text-primary-color font-[500]"
            >
              Resend
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyAccountForm;
